import React from 'react'
import { SESSION_CARDS } from './sessionCardDefinitions.js'

const SESSION_COLOR = '#9b6cc4'

export function SessionCardTray({ layout, onAddCard }) {
  const available = SESSION_CARDS.filter((c) => !layout.includes(c.id))
  if (available.length === 0) return null

  return (
    <div style={styles.tray}>
      <div style={styles.header}>+ Add to session</div>
      <div style={styles.items}>
        {available.map((c) => (
          <button key={c.id} style={styles.btn} onClick={() => onAddCard(c.id)}>
            {c.label}
            {c.core && <span style={styles.dot} title="Recommended">●</span>}
          </button>
        ))}
      </div>
    </div>
  )
}

const styles = {
  tray: {
    border: `1px dashed #d4c4da`,
    borderRadius: '8px',
    padding: '12px 16px',
  },
  header: {
    fontSize: '11px',
    fontWeight: 600,
    color: 'var(--text-secondary)',
    marginBottom: '10px',
    letterSpacing: '-0.01em',
  },
  items: { display: 'flex', flexWrap: 'wrap', gap: '6px' },
  btn: {
    display: 'flex', alignItems: 'center', gap: '4px',
    padding: '4px 10px',
    borderRadius: '12px',
    border: `1px solid #d4c4da`,
    background: 'transparent',
    fontSize: '11px',
    color: 'var(--text-secondary)',
    cursor: 'pointer',
  },
  dot: { fontSize: '7px', color: SESSION_COLOR, lineHeight: 1 },
}
